import React, { useContext } from "react";
import "../css/LogoutPopup.css";
import { useNavigate } from "react-router-dom";

function LogoutPopup(props) {
  const { showLogoutPopup } = props;
  const navigate = useNavigate();

  const logoutAdmin = () => {

    console.log("inside logoutAdmin");
    showLogoutPopup(false);

    // Save data to cookieStorage
    document.cookie = "currentSatusLog=" + JSON.stringify({isAdminLoggedIn: false,});
    document.cookie = "currentSatusLogUser=" + JSON.stringify({ user: "" });
    document.cookie = "current_company_user_type=" + JSON.stringify({ type: "" });

    navigate("/");
  };

  return (
    <div className="LogoutPopup-main-background">
      <div className="LogoutPopup-container-background">
        <div className="LogoutPopup-image-text-container">
          <span>Log Out</span>
          <p>Are you sure?</p>
        </div>
        <div className="LogoutPopup-buttonContainer">
          <button
            className="LogoutPopup-go-back-button LogoutPopup-cancel-button"
            onClick={() => showLogoutPopup(false)}
          >
            Cancel
          </button>
          <button className="LogoutPopup-go-back-button" onClick={logoutAdmin}>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}

export default LogoutPopup;
